module.exports = __webpack_public_path__ + "img/chapter.c1d22b8a.svg";